import styled from 'styled-components'
import { motion } from 'framer-motion' 

const ContNosIndividual = styled(motion.div)`

    text-align: center;
    width: 20%;
    display: inline-block;
    color: white;
    background-color: rgba(16,227,162, 0.45);
    padding: 3em 0.5em;
    border-radius: 0 2em 0 0;
    margin: 1em 1em;
    

    h3
    {

    }

    img
    {
        width: 50%;
    }
    :hover
    {
        box-shadow: 3px 3px 10px #10e3a2;
    }
    `;

export {ContNosIndividual};